// import React, { useState, useEffect } from "react";
// import {
//   Trash2,
//   Plus,
//   X,
//   Upload,
//   Image as ImageIcon,
//   Edit2,
// } from "lucide-react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Loader from "../../components/common/Loader";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

// const Event = () => {
//   const [events, setEvents] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMode, setModalMode] = useState("add");
//   const [currentEvent, setCurrentEvent] = useState(null);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [existingImages, setExistingImages] = useState([]);
//   const [isUploading, setIsUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//   });

//   const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET;
//   const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_NAME;

//   const fetchEvents = async () => {
//     try {
//       const config = {
//         method: "get",
//         maxBodyLength: Infinity,
//         url: `${process.env.REACT_APP_API_URL}/events/get-all`,
//         headers: {},
//       };
//       const startTime = Date.now();
//       const response = await axios.request(config);
//       if (response?.data) {
//         setEvents(response?.data?.data);
//       }
//       const elapsed = Date.now() - startTime;
//       const remaining = Math.max(1000 - elapsed, 0);
//       setTimeout(() => setIsLoading(false), remaining);
//     } catch (err) {
//       console.error("Error fetching events:", err);
//       setError(err.message);
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchEvents();
//   }, []);

//   const handleDelete = (eventId) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         let config = {
//           method: "delete",
//           maxBodyLength: Infinity,
//           url: `${process.env.REACT_APP_API_URL}/events/delete/${eventId}`,
//           headers: {},
//         };
//         axios
//           .request(config)
//           .then((response) => {
//             console.log("Deleted:", response.data);
//             Swal.fire({
//               title: "Deleted!",
//               text: "The event has been deleted successfully.",
//               icon: "success",
//               timer: 1500,
//               showConfirmButton: false,
//             });
//             fetchEvents();
//           })
//           .catch((error) => {
//             console.error("Delete error:", error);
//             Swal.fire({
//               title: "Error!",
//               text: "Something went wrong while deleting the event.",
//               icon: "error",
//             });
//           });
//       } else {
//         Swal.fire({
//           title: "Cancelled",
//           text: "Your event is safe 😊",
//           icon: "info",
//           timer: 1200,
//           showConfirmButton: false,
//         });
//       }
//     });
//   };

//   const handleAddEvent = () => {
//     setModalMode("add");
//     setFormData({ title: "", description: "" });
//     setSelectedFiles([]);
//     setPreviewUrls([]);
//     setExistingImages([]);
//     setCurrentEvent(null);
//     setIsModalOpen(true);
//   };

//   const handleEditEvent = async (event) => {
//     setIsLoading(true);
//     await new Promise((resolve) => setTimeout(resolve, 800));
//     setModalMode("edit");
//     setCurrentEvent(event);
//     setFormData({
//       title: event.title,
//       description: event.description,
//     });
//     setExistingImages(event.images || []);
//     setSelectedFiles([]);
//     setPreviewUrls([]);
//     setIsModalOpen(true);
//     setIsLoading(false);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedFiles([]);
//     setPreviewUrls([]);
//     setExistingImages([]);
//     setFormData({ title: "", description: "" });
//     setCurrentEvent(null);
//     setIsUploading(false);
//     setUploadProgress(0);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleFileSelect = (e) => {
//     const files = Array.from(e.target.files);

//     const validFiles = files.filter((file) => {
//       const isValid = file.type.startsWith("image/");
//       if (!isValid) {
//         Swal.fire({
//           title: "Invalid File",
//           text: `${file.name} is not an image file.`,
//           icon: "error",
//           timer: 2000,
//         });
//       }
//       return isValid;
//     });

//     setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);

//     validFiles.forEach((file) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewUrls((prev) => [...prev, reader.result]);
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const handleRemoveNewFile = (index) => {
//     setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
//     setPreviewUrls((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleRemoveExistingImage = (index) => {
//     setExistingImages((prev) => prev.filter((_, i) => i !== index));
//   };

//   const uploadToCloudinary = async (file) => {
//     const formDataCloud = new FormData();
//     formDataCloud.append("file", file);
//     formDataCloud.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
//     formDataCloud.append("cloud_name", CLOUDINARY_CLOUD_NAME);

//     try {
//       const response = await axios.post(
//         `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
//         formDataCloud
//       );
//       return response.data.secure_url;
//     } catch (error) {
//       console.error("Error uploading to Cloudinary:", error);
//       throw error;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.title.trim()) {
//       Swal.fire({
//         title: "Error!",
//         text: "Please enter event title.",
//         icon: "error",
//       });
//       return;
//     }

//     if (!formData.description.trim()) {
//       Swal.fire({
//         title: "Error!",
//         text: "Please enter event description.",
//         icon: "error",
//       });
//       return;
//     }

//     if (modalMode === "add" && selectedFiles.length === 0) {
//       Swal.fire({
//         title: "Error!",
//         text: "Please select at least one image.",
//         icon: "error",
//       });
//       return;
//     }

//     setIsUploading(true);
//     setUploadProgress(0);

//     try {
//       let uploadedUrls = [...existingImages];

//       if (selectedFiles.length > 0) {
//         const totalFiles = selectedFiles.length;
//         for (let i = 0; i < selectedFiles.length; i++) {
//           const url = await uploadToCloudinary(selectedFiles[i]);
//           uploadedUrls.push(url);
//           setUploadProgress(Math.round(((i + 1) / totalFiles) * 100));
//         }
//       }

//       const data = JSON.stringify({
//         title: formData.title,
//         description: formData.description,
//         images: uploadedUrls,
//       });

//       const config = {
//         method: modalMode === "add" ? "post" : "put",
//         maxBodyLength: Infinity,
//         url:
//           modalMode === "add"
//             ? `${process.env.REACT_APP_API_URL}/events/create`
//             : `${process.env.REACT_APP_API_URL}/events/update/${currentEvent._id}`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       await axios.request(config);

//       Swal.fire({
//         title: "Success!",
//         text: `Event ${
//           modalMode === "add" ? "created" : "updated"
//         } successfully.`,
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       handleCloseModal();
//       fetchEvents();
//     } catch (error) {
//       console.error("Error saving event:", error);
//       Swal.fire({
//         title: "Error!",
//         text: `Something went wrong while ${
//           modalMode === "add" ? "creating" : "updating"
//         } the event.`,
//         icon: "error",
//       });
//       setIsUploading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen p-6 dashboardContainer">
//       <div className="w-full mx-auto">
//         <div className="mb-4 mt-6">
//           <div className="flex justify-between items-center mb-4">
//             <div>
//               <h1 className="text-3xl sm:text-4xl font-bold text-primaryTextColor mb-2">
//                 Events
//               </h1>
//             </div>
//             <button
//               className="bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-all duration-300 shadow-md hover:shadow-lg"
//               onClick={handleAddEvent}
//             >
//               <Plus size={20} />
//               Add Event
//             </button>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {isLoading ? (
//             <Loader />
//           ) : error ? (
//             <div className="col-span-full text-center py-16">
//               <div className="text-6xl mb-4">⚠️</div>
//               <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
//                 Error Loading Events
//               </h3>
//               <p className="text-secondaryTextColor">{error}</p>
//             </div>
//           ) : (
//             events?.map((event) => (
//               <div
//                 key={event?._id}
//                 className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
//               >
//                 <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 flex gap-2">
//                   <button
//                     onClick={() => handleEditEvent(event)}
//                     className="bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition-all shadow-md"
//                   >
//                     <Edit2 size={16} />
//                   </button>
//                   <button
//                     onClick={() => handleDelete(event?._id)}
//                     className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all shadow-md"
//                   >
//                     <Trash2 size={16} />
//                   </button>
//                 </div>

//                 {event?.images && event?.images?.length > 0 && (
//                   <div className="aspect-video overflow-hidden relative">
//                     {event?.images?.length === 1 ? (
//                       <img
//                         src={event?.images[0]}
//                         alt={event?.title}
//                         className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
//                         onError={(e) => {
//                           e.target.src =
//                             "https://via.placeholder.com/400x300?text=Event+Image";
//                         }}
//                       />
//                     ) : (
//                       <Swiper
//                         pagination={{
//                           clickable: true,
//                           dynamicBullets: true,
//                         }}
//                         autoplay={{
//                           delay: 3000,
//                           disableOnInteraction: false,
//                         }}
//                         modules={[Pagination, Autoplay]}
//                         className="w-full h-full"
//                       >
//                         {event?.images?.map((image, index) => (
//                           <SwiperSlide key={index}>
//                             <img
//                               src={image}
//                               alt={`${event?.title} - ${index + 1}`}
//                               className="w-full h-full object-cover"
//                               onError={(e) => {
//                                 e.target.src =
//                                   "https://via.placeholder.com/400x300?text=Event+Image";
//                               }}
//                             />
//                           </SwiperSlide>
//                         ))}
//                       </Swiper>
//                     )}
//                   </div>
//                 )}

//                 <div className="p-4">
//                   <h3 className="text-xl font-bold text-primaryTextColor mb-2 line-clamp-2">
//                     {event?.title}
//                   </h3>
//                   <p className="text-secondaryTextColor text-sm line-clamp-3">
//                     {event?.description}
//                   </p>
//                 </div>

//                 <div className="h-1 bg-gradient-to-r from-primaryColor to-secondaryColor transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
//               </div>
//             ))
//           )}
//         </div>

//         {!isLoading && events.length === 0 && (
//           <div className="text-center py-16">
//             <div className="text-6xl mb-4">📅</div>
//             <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
//               No Events Found
//             </h3>
//             <p className="text-secondaryTextColor mb-6">
//               Start by creating your first event
//             </p>
//             <button
//               onClick={handleAddEvent}
//               className="bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-3 rounded-lg flex items-center gap-2 mx-auto transition-all duration-300"
//             >
//               <Plus size={20} />
//               Add Event
//             </button>
//           </div>
//         )}
//       </div>

//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden">
//             <div className="flex justify-between items-center p-6 border-b">
//               <h2 className="text-2xl font-bold text-primaryTextColor">
//                 {modalMode === "add" ? "Add New Event" : "Edit Event"}
//               </h2>
//               <button
//                 onClick={handleCloseModal}
//                 className="text-gray-500 hover:text-gray-700 transition-colors"
//                 disabled={isUploading}
//               >
//                 <X size={24} />
//               </button>
//             </div>

//             <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
//               <div className="mb-4">
//                 <label className="block text-sm font-semibold text-primaryTextColor mb-2">
//                   Event Title *
//                 </label>
//                 <input
//                   type="text"
//                   name="title"
//                   value={formData?.title}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryColor focus:border-transparent"
//                   placeholder="Enter event title"
//                   disabled={isUploading}
//                 />
//               </div>

//               <div className="mb-6">
//                 <label className="block text-sm font-semibold text-primaryTextColor mb-2">
//                   Event Description *
//                 </label>
//                 <textarea
//                   name="description"
//                   value={formData.description}
//                   onChange={handleInputChange}
//                   rows={4}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryColor focus:border-transparent resize-none"
//                   placeholder="Enter event description"
//                   disabled={isUploading}
//                 />
//               </div>

//               {modalMode === "edit" && existingImages.length > 0 && (
//                 <div className="mb-6">
//                   <h3 className="text-lg font-semibold text-primaryTextColor mb-3">
//                     Current Images ({existingImages.length})
//                   </h3>
//                   <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
//                     {existingImages.map((url, index) => (
//                       <div key={index} className="relative group">
//                         <div className="aspect-square rounded-lg overflow-hidden border border-gray-200">
//                           <img
//                             src={url}
//                             alt={`Existing ${index + 1}`}
//                             className="w-full h-full object-cover"
//                           />
//                         </div>
//                         {!isUploading && (
//                           <button
//                             type="button"
//                             onClick={() => handleRemoveExistingImage(index)}
//                             className="absolute -top-2 -right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
//                           >
//                             <X size={16} />
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <div className="mb-6">
//                 <label className="block text-sm font-semibold text-primaryTextColor mb-3">
//                   {modalMode === "edit" ? "Add More Images" : "Event Images *"}
//                 </label>
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-primaryColor transition-colors">
//                   <input
//                     type="file"
//                     multiple
//                     accept="image/*"
//                     onChange={handleFileSelect}
//                     className="hidden"
//                     id="file-upload"
//                     disabled={isUploading}
//                   />
//                   <label
//                     htmlFor="file-upload"
//                     className="cursor-pointer flex flex-col items-center"
//                   >
//                     <ImageIcon size={48} className="text-gray-400 mb-3" />
//                     <span className="text-primaryColor font-semibold mb-1">
//                       Click to upload
//                     </span>
//                     <span className="text-sm text-gray-500">
//                       or drag and drop images here
//                     </span>
//                     <span className="text-xs text-gray-400 mt-2">
//                       PNG, JPG, JPEG, GIF up to 10MB
//                     </span>
//                   </label>
//                 </div>
//               </div>

//               {previewUrls.length > 0 && (
//                 <div>
//                   <h3 className="text-lg font-semibold text-primaryTextColor mb-3">
//                     New Images ({selectedFiles.length})
//                   </h3>
//                   <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
//                     {previewUrls.map((url, index) => (
//                       <div key={index} className="relative group">
//                         <div className="aspect-square rounded-lg overflow-hidden border border-gray-200">
//                           <img
//                             src={url}
//                             alt={`Preview ${index + 1}`}
//                             className="w-full h-full object-cover"
//                           />
//                         </div>
//                         {!isUploading && (
//                           <button
//                             type="button"
//                             onClick={() => handleRemoveNewFile(index)}
//                             className="absolute -top-2 -right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
//                           >
//                             <X size={16} />
//                           </button>
//                         )}
//                         <p className="text-xs text-gray-600 mt-1 truncate">
//                           {selectedFiles[index]?.name}
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {isUploading && (
//                 <div className="mt-6">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-sm font-semibold text-primaryTextColor">
//                       {modalMode === "add"
//                         ? "Creating event..."
//                         : "Updating event..."}
//                     </span>
//                     <span className="text-sm text-gray-600">
//                       {uploadProgress}%
//                     </span>
//                   </div>
//                   <div className="w-full bg-gray-200 rounded-full h-2">
//                     <div
//                       className="bg-primaryColor h-2 rounded-full transition-all duration-300"
//                       style={{ width: `${uploadProgress}%` }}
//                     ></div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end gap-3 p-6 border-t bg-gray-50">
//               <button
//                 type="button"
//                 onClick={handleCloseModal}
//                 className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-all"
//                 disabled={isUploading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={handleSubmit}
//                 disabled={isUploading}
//                 className="bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 {isUploading ? (
//                   <>
//                     <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
//                     {modalMode === "add" ? "Creating..." : "Updating..."}
//                   </>
//                 ) : (
//                   <>
//                     <Upload size={18} />
//                     {modalMode === "add" ? "Create Event" : "Update Event"}
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Event;

import React, { useState, useEffect } from "react";
import {
  Trash2,
  Plus,
  X,
  Upload,
  Image as ImageIcon,
  Edit2,
  Video,
} from "lucide-react";
import Swal from "sweetalert2";
import Loader from "../../components/common/Loader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Event = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [currentEvent, setCurrentEvent] = useState(null);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [mediaCaptions, setMediaCaptions] = useState({});
  const [mediaNames, setMediaNames] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [formData, setFormData] = useState({
    eventName: "",
    description: "",
  });

  const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET;
  const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_NAME;
  const API_URL = process.env.REACT_APP_API_URL;

  const fetchEvents = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${API_URL}/events/get-all`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.success && data?.data) {
        setEvents(data.data);
      } else {
        throw new Error(data?.message || "Failed to fetch events");
      }
    } catch (err) {
      console.error("Error fetching events:", err);
      setError(err.message);
      Swal.fire({
        title: "Error!",
        text: "Failed to load events. Please try again.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleDelete = async (eventId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${API_URL}/events/delete/${eventId}`, {
          method: "DELETE",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success) {
          Swal.fire({
            title: "Deleted!",
            text: "The event has been deleted successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          fetchEvents();
        } else {
          throw new Error(data.message || "Failed to delete event");
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while deleting the event.",
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        title: "Cancelled",
        text: "Your event is safe 😊",
        icon: "info",
        timer: 1200,
        showConfirmButton: false,
      });
    }
  };

  const handleAddEvent = () => {
    setModalMode("add");
    setFormData({ eventName: "", description: "" });
    setMediaFiles([]);
    setMediaCaptions({});
    setMediaNames({});
    setCurrentEvent(null);
    setIsModalOpen(true);
  };

  const handleEditEvent = async (event) => {
    try {
      setIsLoading(true);
      setModalMode("edit");
      setCurrentEvent(event);
      setFormData({
        eventName: event.eventName || "",
        description: event.description || "",
      });

      // Set existing media files
      const existingMedia = event.media || [];
      setMediaFiles(existingMedia);

      // Initialize captions and names for existing media
      const captions = {};
      const names = {};

      existingMedia.forEach((item) => {
        const mediaId = item._id || item.id;
        if (mediaId) {
          captions[mediaId] = item.captions || [];
          names[mediaId] = item.name || "";
        }
      });

      setMediaCaptions(captions);
      setMediaNames(names);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error in edit event:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to load event for editing.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    if (isUploading) {
      Swal.fire({
        title: "Upload in Progress",
        text: "Please wait for the upload to complete before closing.",
        icon: "warning",
      });
      return;
    }

    setIsModalOpen(false);
    setMediaFiles([]);
    setMediaCaptions({});
    setMediaNames({});
    setFormData({ eventName: "", description: "" });
    setCurrentEvent(null);
    setIsUploading(false);
    setUploadProgress(0);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleMediaNameChange = (mediaId, name) => {
    setMediaNames((prev) => ({
      ...prev,
      [mediaId]: name,
    }));
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      const isImage = file.type.startsWith("image/");
      const isVideo = file.type.startsWith("video/");

      if (!isImage && !isVideo) {
        invalidFiles.push(file.name);
        return;
      }

      if (isVideo && file.size > 50 * 1024 * 1024) {
        invalidFiles.push(`${file.name} (exceeds 30MB limit)`);
        return;
      }

      validFiles.push({
        file,
        type: isImage ? "image" : "video",
        id: `new-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      });
    });

    // Show warnings for invalid files
    if (invalidFiles.length > 0) {
      Swal.fire({
        title: "Invalid Files",
        html: `The following files were skipped:<br>${invalidFiles.join(
          "<br>"
        )}`,
        icon: "warning",
        timer: 3000,
      });
    }

    // Add valid files
    if (validFiles.length > 0) {
      setMediaFiles((prev) => [...prev, ...validFiles]);

      const newCaptions = { ...mediaCaptions };
      const newNames = { ...mediaNames };

      validFiles.forEach((media) => {
        newCaptions[media.id] = [];
        newNames[media.id] = "";
      });

      setMediaCaptions(newCaptions);
      setMediaNames(newNames);
    }

    // Reset file input
    e.target.value = "";
  };

  const handleAddCaption = (mediaId, captionText) => {
    if (!captionText?.trim()) return;

    setMediaCaptions((prev) => ({
      ...prev,
      [mediaId]: [...(prev[mediaId] || []), captionText.trim()],
    }));
  };

  const handleRemoveCaption = (mediaId, captionIndex) => {
    setMediaCaptions((prev) => ({
      ...prev,
      [mediaId]: (prev[mediaId] || []).filter((_, i) => i !== captionIndex),
    }));
  };

  const handleRemoveMedia = (mediaId) => {
    setMediaFiles((prev) =>
      prev.filter((m) => {
        const id = m.id || m._id;
        return id !== mediaId;
      })
    );

    setMediaCaptions((prev) => {
      const newCaptions = { ...prev };
      delete newCaptions[mediaId];
      return newCaptions;
    });

    setMediaNames((prev) => {
      const newNames = { ...prev };
      delete newNames[mediaId];
      return newNames;
    });
  };

  const uploadToCloudinary = async (file, fileType) => {
    const formDataCloud = new FormData();
    formDataCloud.append("file", file);
    formDataCloud.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
    formDataCloud.append("cloud_name", CLOUDINARY_CLOUD_NAME);

    const resourceType = fileType === "video" ? "video" : "image";
    formDataCloud.append("resource_type", resourceType);

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`,
        {
          method: "POST",
          body: formDataCloud,
        }
      );

      if (!response.ok) {
        throw new Error(`Cloudinary upload failed: ${response.status}`);
      }

      const data = await response.json();
      return data.secure_url;
    } catch (error) {
      console.error("Error uploading to Cloudinary:", error);
      throw new Error(`Failed to upload ${file.name}: ${error.message}`);
    }
  };

  const validateForm = () => {
    if (!formData.eventName.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Please enter event name.",
        icon: "error",
      });
      return false;
    }

    if (!formData.description.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Please enter event description.",
        icon: "error",
      });
      return false;
    }

    if (modalMode === "add" && mediaFiles.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one image or video.",
        icon: "error",
      });
      return false;
    }

    // Check if all media have names
    const hasMediaWithoutNames = mediaFiles.some((m) => {
      const mediaId = m.id || m._id;
      return !mediaNames[mediaId] || !mediaNames[mediaId].trim();
    });

    if (hasMediaWithoutNames) {
      Swal.fire({
        title: "Error!",
        text: "Please add a name for each media file.",
        icon: "error",
      });
      return false;
    }

    // Check if all media have at least one caption
    const hasMediaWithoutCaptions = mediaFiles.some((m) => {
      const mediaId = m.id || m._id;
      return !mediaCaptions[mediaId] || mediaCaptions[mediaId].length === 0;
    });

    if (hasMediaWithoutCaptions) {
      Swal.fire({
        title: "Error!",
        text: "Please add at least one caption for each media file.",
        icon: "error",
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const mediaArray = [];
      const newMediaFiles = mediaFiles.filter((m) => m.file);
      const existingMediaFiles = mediaFiles.filter((m) => !m.file);

      let uploadedCount = 0;
      const totalFiles = newMediaFiles.length;

      // Upload new files to Cloudinary
      for (let media of newMediaFiles) {
        try {
          const url = await uploadToCloudinary(media.file, media.type);
          uploadedCount++;
          setUploadProgress(Math.round((uploadedCount / totalFiles) * 100));

          mediaArray.push({
            name: mediaNames[media.id] || "",
            type: media.type,
            url,
            captions: mediaCaptions[media.id] || [],
          });
        } catch (uploadError) {
          console.error(`Failed to upload ${media.file.name}:`, uploadError);
          throw uploadError;
        }
      }

      // Add existing media files
      existingMediaFiles.forEach((media) => {
        const mediaId = media._id || media.id;
        mediaArray.push({
          name: mediaNames[mediaId] || media.name || "",
          type: media.type,
          url: media.url,
          captions: mediaCaptions[mediaId] || media.captions || [],
        });
      });

      const payload = {
        eventName: formData.eventName.trim(),
        description: formData.description.trim(),
        media: mediaArray,
      };

      const url =
        modalMode === "add"
          ? `${API_URL}/events/create`
          : `${API_URL}/events/update/${currentEvent._id}`;

      const response = await fetch(url, {
        method: modalMode === "add" ? "POST" : "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          title: "Success!",
          text: `Event ${
            modalMode === "add" ? "created" : "updated"
          } successfully.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        handleCloseModal();
        fetchEvents();
      } else {
        throw new Error(result.message || "Failed to save event");
      }
    } catch (error) {
      console.error("Error saving event:", error);
      Swal.fire({
        title: "Error!",
        text:
          error.message ||
          `Something went wrong while ${
            modalMode === "add" ? "creating" : "updating"
          } the event.`,
        icon: "error",
      });
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const renderMediaItem = (media) => {
    const mediaId = media._id || media.id;
    const isNewMedia = !!media.file;
    const previewUrl = isNewMedia ? URL.createObjectURL(media.file) : media.url;

    return (
      <div key={mediaId} className="border border-gray-200 rounded-lg p-4">
        <div className="flex items-start gap-4">
          <div className="relative w-20 h-20 bg-gray-100 rounded overflow-hidden flex-shrink-0">
            {media.type === "video" ? (
              <video
                src={previewUrl}
                className="w-full h-full object-cover"
                controls={false}
              />
            ) : (
              <img
                src={previewUrl}
                alt="Preview"
                className="w-full h-full object-cover"
              />
            )}
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
              {media.type === "video" ? (
                <Video size={16} className="text-white" />
              ) : (
                <ImageIcon size={16} className="text-white" />
              )}
            </div>
          </div>

          <div className="flex-1">
            <p className="text-sm font-semibold text-primaryTextColor capitalize mb-1">
              {media.type}
            </p>
            {/* {isNewMedia && (
              <p className="text-xs text-gray-600 truncate mb-2">
                {media.file.name}
              </p>
            )} */}

            <div className="mb-3">
              <input
                type="text"
                placeholder="Media name *"
                value={mediaNames[mediaId] || ""}
                onChange={(e) => handleMediaNameChange(mediaId, e.target.value)}
                disabled={isUploading}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-primaryColor focus:border-transparent"
              />
            </div>

            <div className="space-y-2">
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Add caption..."
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && e.target.value.trim()) {
                      handleAddCaption(mediaId, e.target.value);
                      e.target.value = "";
                    }
                  }}
                  disabled={isUploading}
                  className="flex-1 px-3 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-primaryColor focus:border-transparent"
                />
                <button
                  type="button"
                  onClick={(e) => {
                    const input = e.target.previousSibling;
                    if (input.value.trim()) {
                      handleAddCaption(mediaId, input.value);
                      input.value = "";
                    }
                  }}
                  disabled={isUploading}
                  className="bg-primaryBtnColor text-white px-3 py-1 rounded hover:bg-opacity-90 transition-all disabled:opacity-50 text-sm"
                >
                  Add
                </button>
              </div>

              {mediaCaptions[mediaId]?.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {mediaCaptions[mediaId].map((caption, idx) => (
                    <div
                      key={idx}
                      className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded flex items-center gap-1"
                    >
                      {caption}
                      <button
                        type="button"
                        onClick={() => handleRemoveCaption(mediaId, idx)}
                        disabled={isUploading}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <X size={12} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {!isUploading && (
              <button
                type="button"
                onClick={() => handleRemoveMedia(mediaId)}
                className="text-red-500 hover:text-red-700 transition-colors mt-2 text-sm flex items-center gap-1"
              >
                <Trash2 size={14} />
                Remove
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen p-6 dashboardContainer">
      <div className="w-full mx-auto">
        <div className="mb-4 mt-6">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-primaryTextColor mb-2">
                Events
              </h1>
            </div>
            <button
              className="bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-all duration-300 shadow-md hover:shadow-lg"
              onClick={handleAddEvent}
            >
              <Plus size={20} />
              Add Event
            </button>
          </div>
        </div>

        {isLoading ? (
          <Loader />
        ) : error ? (
          <div className="col-span-full text-center py-16">
            <div className="text-6xl mb-4">⚠️</div>
            <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
              Error Loading Events
            </h3>
            <p className="text-secondaryTextColor">{error}</p>
            <button
              onClick={fetchEvents}
              className="mt-4 bg-primaryBtnColor text-white px-6 py-2 rounded-lg hover:bg-opacity-90 transition-all"
            >
              Retry
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {events.map((event) => (
              <div
                key={event._id}
                className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
              >
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 flex gap-2">
                  <button
                    onClick={() => handleEditEvent(event)}
                    className="bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition-all shadow-md"
                  >
                    <Edit2 size={16} />
                  </button>
                  <button
                    onClick={() => handleDelete(event._id)}
                    className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all shadow-md"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>

                {event.media && event.media.length > 0 && (
                  <div className="aspect-video overflow-hidden relative">
                    {event.media.length === 1 ? (
                      event.media[0].type === "video" ? (
                        <video
                          src={event.media[0].url}
                          className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
                          controls={false}
                          muted
                        />
                      ) : (
                        <img
                          src={event.media[0].url}
                          alt={event.media[0].name || event.eventName}
                          className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/400x300?text=Event+Media";
                          }}
                        />
                      )
                    ) : (
                      <Swiper
                        pagination={{
                          clickable: true,
                          dynamicBullets: true,
                        }}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        modules={[Pagination, Autoplay]}
                        className="w-full h-full"
                      >
                        {event.media.map((media, index) => (
                          <SwiperSlide key={index}>
                            {media.type === "video" ? (
                              <video
                                src={media.url}
                                className="w-full h-full object-cover"
                                controls={false}
                                muted
                              />
                            ) : (
                              <img
                                src={media.url}
                                alt={
                                  media.name ||
                                  `${event.eventName} - ${index + 1}`
                                }
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.src =
                                    "https://via.placeholder.com/400x300?text=Event+Media";
                                }}
                              />
                            )}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                  </div>
                )}

                <div className="p-4">
                  <h3 className="text-xl font-bold text-primaryTextColor mb-2 line-clamp-2">
                    {event.eventName}
                  </h3>
                  <p className="text-secondaryTextColor text-sm line-clamp-3">
                    {event.description}
                  </p>
                </div>

                <div className="h-1 bg-gradient-to-r from-primaryColor to-secondaryColor transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </div>
            ))}
          </div>
        )}

        {!isLoading && events.length === 0 && !error && (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">📅</div>
            <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
              No Events Found
            </h3>
            <p className="text-secondaryTextColor mb-6">
              Start by creating your first event
            </p>
            <button
              onClick={handleAddEvent}
              className="bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-3 rounded-lg flex items-center gap-2 mx-auto transition-all duration-300"
            >
              <Plus size={20} />
              Add Event
            </button>
          </div>
        )}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-2xl font-bold text-primaryTextColor">
                {modalMode === "add" ? "Add New Event" : "Edit Event"}
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50"
                disabled={isUploading}
              >
                <X size={24} />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
                <div className="mb-4">
                  <label className="block text-sm font-semibold text-primaryTextColor mb-2">
                    Event Name *
                  </label>
                  <input
                    type="text"
                    name="eventName"
                    value={formData.eventName}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryColor focus:border-transparent disabled:opacity-50"
                    placeholder="Enter event name"
                    disabled={isUploading}
                  />
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-semibold text-primaryTextColor mb-2">
                    Event Description *
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryColor focus:border-transparent resize-none disabled:opacity-50"
                    placeholder="Enter event description"
                    disabled={isUploading}
                  />
                </div>

                {modalMode === "edit" &&
                  mediaFiles.filter((m) => !m.file).length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-primaryTextColor mb-3">
                        Current Media (
                        {mediaFiles.filter((m) => !m.file).length})
                      </h3>
                      <div className="space-y-4">
                        {mediaFiles.filter((m) => !m.file).map(renderMediaItem)}
                      </div>
                    </div>
                  )}

                {mediaFiles.filter((m) => m.file).length > 0 && (
                  <div className="mb-6">
                    <h3 className="text-lg font-semibold text-primaryTextColor mb-3">
                      New Media ({mediaFiles.filter((m) => m.file).length})
                    </h3>
                    <div className="space-y-4">
                      {mediaFiles.filter((m) => m.file).map(renderMediaItem)}
                    </div>
                  </div>
                )}

                <div className="mb-6">
                  <label className="block text-sm font-semibold text-primaryTextColor mb-3">
                    {modalMode === "edit"
                      ? "Add More Media"
                      : "Upload Media (Images & Videos) *"}
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-primaryColor transition-colors">
                    <input
                      type="file"
                      multiple
                      accept="image/*,video/*"
                      onChange={handleFileSelect}
                      className="hidden"
                      id="file-upload"
                      disabled={isUploading}
                    />
                    <label
                      htmlFor="file-upload"
                      className={`cursor-pointer flex flex-col items-center ${
                        isUploading ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    >
                      <Upload size={48} className="text-gray-400 mb-3" />
                      <span className="text-primaryColor font-semibold mb-1">
                        Click to upload
                      </span>
                      <span className="text-sm text-gray-500">
                        or drag and drop media here
                      </span>
                      <span className="text-xs text-gray-400 mt-2">
                        Images: PNG, JPG, JPEG, GIF | Videos: MP4, WebM (Max
                        30MB)
                      </span>
                    </label>
                  </div>
                </div>

                {isUploading && (
                  <div className="mb-6">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm font-semibold text-primaryTextColor">
                        Uploading...
                      </span>
                      <span className="text-sm text-gray-600">
                        {uploadProgress}%
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-primaryColor h-2 rounded-full transition-all duration-300"
                        style={{ width: `${uploadProgress}%` }}
                      ></div>
                    </div>
                  </div>
                )}
              </div>

              <div className="flex justify-end gap-3 p-6 border-t">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-all disabled:opacity-50"
                  disabled={isUploading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isUploading}
                  className="bg-primaryBtnColor text-white px-6 py-2 rounded-lg hover:bg-opacity-90 transition-all disabled:opacity-50 flex items-center gap-2"
                >
                  {isUploading ? (
                    <>
                      <Loader />
                      {modalMode === "add" ? "Creating..." : "Updating..."}
                    </>
                  ) : (
                    <>{modalMode === "add" ? "Create Event" : "Update Event"}</>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Event;
